import RestApi from './../../api/rest-api-client'

const srvcEndpoint = '/secure_file'

const SecureFile = {
  // path → signed URL (or null if forbidden / missing).
  getUrl: async path => {
    try {
      const res = await RestApi.request('POST', srvcEndpoint, { path })
      return (res && res.url) || null
    } catch (ex) {
      return null
    }
  },
  // paths[] → { path: url|null }.
  getUrls: async paths => {
    try {
      const res = await RestApi.request('POST', srvcEndpoint, { paths })
      return (res && res.urls) || {}
    } catch (ex) {
      return {}
    }
  },
  // Open a sensitive file in a new tab via a signed URL. Popup-safe: opens blank in the click gesture, then redirects.
  openSigned: async path => {
    const w = window.open('', '_blank')
    const url = await SecureFile.getUrl(path)
    if (url && w) w.location.href = url
    else if (w) w.close()
  },

  // Extract the Storage object path from a Firebase `/o/<encoded-path>?alt=media` URL (else null).
  pathFromStorageUrl: link => {
    if (typeof link !== 'string') return null
    const m = link.match(/\/o\/([^?]+)/)
    if (!m) return null
    try {
      return decodeURIComponent(m[1])
    } catch (ex) {
      return null
    }
  },

  // Open any resource link correctly: sensitive-prefix Storage objects go through the authorized
  // signer (agent-only); public assets and external links open directly. Popup-safe for the signed path.
  openResource: link => {
    const path = SecureFile.pathFromStorageUrl(link)
    // backoffice/ + resources/ libraries are denied to tokenless reads → must be signed.
    if (path && /^(backoffice|resources)\//.test(path)) return SecureFile.openSigned(path)
    // public prefixes (agency_document, logos, …) and external URLs open directly.
    window.open(link, '_blank')
    return Promise.resolve()
  },
}

export default SecureFile
